package one.healthium.onboarding.ui.models

enum class HeightUnit {
    Ft,
    Cm
}

fun HeightUnit.correspondingWeightUnit(): WeightUnit {
    return when (this) {
        HeightUnit.Ft -> WeightUnit.Lb
        HeightUnit.Cm -> WeightUnit.Kg
    }
}
